export default __webpack_public_path__ + "media/images/backgrounds/cream-vegetables-bg-39e5bfd68a74e706b763b96a58dfef80.svg";